/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Twitter = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 29 24" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M25.705 5.802v.753A16.717 16.717 0 0 1 0 20.645c.464.049.931.074 1.398.076a11.77 11.77 0 0 0 7.298-2.52 5.87 5.87 0 0 1-5.485-4.071c.379.086.765.137 1.153.154a5.731 5.731 0 0 0 1.536-.216 5.885 5.885 0 0 1-4.717-5.761v-.17a5.731 5.731 0 0 0 2.658.738A5.885 5.885 0 0 1 1.997 1.07a16.625 16.625 0 0 0 12.108 6.146 5.885 5.885 0 0 1 10.018-5.362 12.046 12.046 0 0 0 3.733-1.4 5.915 5.915 0 0 1-2.596 3.227 11.83 11.83 0 0 0 3.38-.922 11.754 11.754 0 0 1-2.935 3.042z" />
      </g>
    </svg>
  </span>
);

Twitter.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Twitter.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Twitter;
